import React from "react";
import { Box, Typography } from "digiwash-components";

interface PropsType {
  items: string[];
}

function ServicesPrivilegeList(props: PropsType) {
  return (
    <Box bg="yellow.light200" br="l" py="xm" px="xxl">
      {props.items?.map((item) => {
        return (
          <Typography fs="s" color="gray.light950">
            - {item}
          </Typography>
        );
      })}
    </Box>
  );
}

export default ServicesPrivilegeList;
